import React from 'react';
import { colorPalette } from 'shared/constants';
import { formatNumber } from 'shared/utils';
import { Button } from 'src/components/design-system';
import styles from '../my-content.module.scss';

/**
 * Button that displays views count and triggers the views modal
 * @param {Object} props
 * @param {Object} props.record - The data record
 * @param {string} props.period - The period key ('last90Days' or 'total')
 * @param {Function} props.onViewsClick - Handler when views button is clicked
 */
export function ViewsModalTriggerButton({ record, period, onViewsClick }) {
  if (!record.analytics?.views) return '-';

  const views = record.analytics.views[period] || 0;
  const uniqueViews = record.analytics.uniqueViews[period] || 0;

  return (
    <Button
      type="link"
      className={styles.viewsButton}
      style={{ color: colorPalette.primary }}
      onClick={() => onViewsClick({ item: record, period })}>
      <b>{formatNumber(views)}</b>
      <br />
      {formatNumber(uniqueViews)} unique
    </Button>
  );
}
